import React from 'react';

import Button from './Button';
import Form from './Form';
import styles from './ModalSelectionItem.module.scss';

const { Item } = Form;

const ModalSelectionItem = ({
    onOpenModal,
    emptyMessage = 'Selecione um valor',
    searchMessage = 'Procurar',
    meta = {},
    value,
    label,
    required,
    render,
}) => {
    const {
        valid, touched, error, submitError,
    } = meta;

    const renderValue = () => {
        if (render) {
            return render();
        }

        if (!value) {
            return (
                <div className={styles.placeholder}>
                    {emptyMessage}
                </div>
            );
        }
        return (
            <div className={styles.value}>
                {value.label}
            </div>
        );
    };

    const getValidateStatus = () => {
        if (!touched) return null;

        return valid ? 'success' : 'error';
    };

    const renderHelp = () => {
        if (touched && !valid) {
            return error || submitError;
        }

        return null;
    };

    return (
        <Item
            label={label}
            required={required}
            help={renderHelp()}
            validateStatus={getValidateStatus()}
        >
            <div className={styles.content}>
                {renderValue()}
                <Button onClick={onOpenModal}>
                    {searchMessage}
                </Button>
            </div>
        </Item>
    );
};

export default ModalSelectionItem;
